import resolveConfig from 'tailwindcss/resolveConfig'

export const tailwindConfig = () => {
    // Tailwind config
    return resolveConfig('./src/css/tailwind.config.ts')
}
